import { formatNumericValue, getChartDataset, parseNumericValue } from "../../../utils/chartData";
var normalizeMunicipioName = function (value) { return value.trim(); };
var canonicalizeMunicipioName = function (value) {
    return value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[’']/g, "")
        .replace(/[^a-zA-Z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
};
var fixKnownMunicipioTypos = function (value) {
    var _a;
    var aliases = {
        "baixa grande do ribeira": "baixa grande do ribeiro",
    };
    return (_a = aliases[value]) !== null && _a !== void 0 ? _a : value;
};
var resolveMunicipioGeoName = function (value, geoNameByCanonical) {
    var _a;
    var canonical = fixKnownMunicipioTypos(canonicalizeMunicipioName(normalizeMunicipioName(value)));
    return (_a = geoNameByCanonical.get(canonical)) !== null && _a !== void 0 ? _a : normalizeMunicipioName(value);
};
export function buildMunicipiosMapOption(data, mapKey, geoJson) {
    var _a;
    var dataset = getChartDataset(data);
    var geoNameByCanonical = new Map();
    ((_a = geoJson === null || geoJson === void 0 ? void 0 : geoJson.features) !== null && _a !== void 0 ? _a : []).forEach(function (feature) {
        var _a;
        var name = (_a = feature.properties) === null || _a === void 0 ? void 0 : _a.name;
        if (!name)
            return;
        geoNameByCanonical.set(canonicalizeMunicipioName(name), name);
    });
    var values = dataset.map(function (item) {
        var _a, _b, _c;
        return ({
            name: resolveMunicipioGeoName(String((_b = (_a = item.cidade) !== null && _a !== void 0 ? _a : item.name) !== null && _b !== void 0 ? _b : ""), geoNameByCanonical),
            value: parseNumericValue((_c = item.total) !== null && _c !== void 0 ? _c : item.value),
        });
    });
    var maxValue = values.reduce(function (currentMax, item) { return Math.max(currentMax, item.value); }, 0);
    return {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(255,255,255,0.96)",
            borderColor: "#ECEEF4",
            borderWidth: 1,
            textStyle: {
                fontFamily: "Montserrat, sans-serif",
                color: "#374151",
                fontSize: 13,
            },
            extraCssText: "box-shadow: 0 4px 20px rgba(0,0,0,0.08); border-radius: 10px;",
            formatter: function (params) {
                var _a;
                var value = params.value == null ? 0 : params.value;
                return "<strong>".concat((_a = params.name) !== null && _a !== void 0 ? _a : "Município", "</strong><br/><strong>").concat(formatNumericValue(value), "</strong> casos");
            },
        },
        visualMap: {
            min: 0,
            max: maxValue || 1,
            left: "right",
            bottom: "6%",
            text: ["Mais", "Menos"],
            calculable: true,
            textStyle: {
                fontFamily: "Montserrat, sans-serif",
                color: "#374151",
            },
            inRange: {
                color: ["#FDE7EF", "#F8B4CC", "#F472B6", "#EC4899", "#BE185D"],
            },
        },
        series: [
            {
                type: "map",
                map: mapKey,
                roam: true,
                zoom: 1,
                nameProperty: "name",
                selectedMode: false,
                emphasis: {
                    label: { show: false },
                    itemStyle: {
                        areaColor: "#7C3AED",
                    },
                },
                itemStyle: {
                    borderColor: "#FFFFFF",
                    borderWidth: 0.8,
                    areaColor: "#F9FAFB",
                },
                data: values,
            },
        ],
    };
}
